import * as React from 'react';
import { IconClose16 } from '@cian/ui-kit';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function CloseIcon(_ref) {
  let {
    onClick
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: styles['close'],
    onClick: onClick,
    children: /*#__PURE__*/_jsx(IconClose16, {
      color: "icon-inverted-default"
    })
  });
}